import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { CONTENT_EDITOR_TOPBAR_SCOPE } from '@lumapps/designer/constants';
import { ConfirmDialog } from '@lumapps/lumx-dialogs/components/ConfirmDialog';
import { mdiClose } from '@lumapps/lumx/icons';
import { IconButton } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { useCloseContentEditorRedirect } from './useCloseContentEditorRedirect';

export interface CloseButtonProps {
    contentId?: string;
    /** Legacy content editor has changes */
    hasChanges?: () => boolean;
}

/**
 * Content editor close button
 */
export const CloseButton = ({ contentId, hasChanges }: CloseButtonProps) => {
    const { translateKey } = useTranslate();
    const { get } = useDataAttributes(CONTENT_EDITOR_TOPBAR_SCOPE);
    const { closeContentEditor, closeConfirmDialogProps } = useCloseContentEditorRedirect(contentId, { hasChanges });

    return (
        <>
            <IconButton
                label={translateKey(GLOBAL.CLOSE)}
                onClick={closeContentEditor}
                style={{ flexShrink: 0 }}
                emphasis="low"
                icon={mdiClose}
                {...get({ element: 'close' })}
            />
            {closeConfirmDialogProps && <ConfirmDialog {...closeConfirmDialogProps} />}
        </>
    );
};
